<template>
  <div class="information" :class="{ hidden }">
    <button class="information__toggle information__toggle--open" @click="toggle">Information</button>
    <div v-if="showContent" class="information__overlay">
      <button class="information__toggle information__toggle--close" @click="toggle">Close</button>
      <div class="information__content" v-html="page.text"></div>
    </div>
  </div>
</template>

<script>
import EventBus from '../util/EventBus'

export default {
  name: 'information',
  components: {
  },
  data () {
    return {
      showContent: false,
      hidden: false
    }
  },
  created () {
  },
  destroyed () {
  },
  computed: {
    page () {
      return this.$store.getters.getPagesByType('Information')[0]
    },
    phone () {
      return this.$store.state.app.phone
    }
  },
  methods: {
    toggle () {
      this.showContent = !this.showContent
    },
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.information {
  &.hidden {
    visibility: hidden;
  }

  &__toggle {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    cursor: pointer;

    &--close {
      position: absolute;
      top: var(--padding);
      right: var(--padding);
    }
  }

  &__overlay {
    position: fixed;
    inset: 0;
    background: var(--white);
    color: var(--black);
    z-index: 100;
    padding: var(--padding);
    overflow-y: auto;
  }
}

</style>



// WEBPACK FOOTER //
// client/components/Information.vue